import { Spin } from 'antd'
import { ThumbnailImage } from 'features/assetDatabase/components/ThumbnailImage'
import { useRolodexSignedURLs } from 'features/rolodex'
import React, { useState } from 'react'
import styled from 'styled-components'

import { FallbackImage } from './FallbackImage'

const CenteredSpin = styled(Spin)`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const PrimaryAssetImage: React.FC<{
  primaryImageID: string
  assetModelType?: string
  showThumbnail?: boolean
  onImageLoadStatus?: (isLoaded: boolean) => void
}> = ({
  primaryImageID,
  assetModelType,
  showThumbnail = false,
  onImageLoadStatus,
}) => {
  const [imageError, setImageError] = useState<boolean>(false)
  const { url: primaryImageURL, isLoading } = useRolodexSignedURLs({
    entry_id: primaryImageID,
    path: primaryImageID,
  })

  React.useEffect(() => {
    if (!isLoading && onImageLoadStatus) {
      onImageLoadStatus(!imageError && Boolean(primaryImageURL))
    }
  }, [imageError, isLoading, primaryImageURL, onImageLoadStatus])

  return isLoading ? (
    <CenteredSpin spinning={true} />
  ) : !imageError && primaryImageURL ? (
    <ThumbnailImage
      key={primaryImageID}
      src={primaryImageURL}
      alt=''
      onError={() => setImageError(true)}
    />
  ) : (
    <FallbackImage
      assetModelType={assetModelType}
      showThumbnail={showThumbnail}
    />
  )
}
